import { render } from "./cpt-img-quota-option.vue?vue&type=template&id=691fda34"
import script from "./cpt-img-quota-option.vue?vue&type=script&lang=js"
export * from "./cpt-img-quota-option.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__